module.exports = __webpack_public_path__ + "img/mp.91055a8.svg";